export default {"src":"/_next/static/media/Text.1dd0936b.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};